import { defineStore } from "pinia";
import { confidentialLogging_actions } from "./confidentialLogging";

export const useLogsStore = defineStore("logs", {
  actions: confidentialLogging_actions
});
